module.exports = __webpack_public_path__ + "static/media/nav-home.26f08934.svg";